import React from 'react';
import PropTypes from 'prop-types';
import { PageContext } from './PageContext';
import { Config } from '../Config';
import { TrackingUtils } from '../TrackingUtils';

export function PageContextProvider(props) {
    const entryPoint = Config.get('entryPoint');

    const category = {
        dp: TrackingUtils.CATEGORY.DP,
        home: TrackingUtils.CATEGORY.HOME,
        flights: TrackingUtils.CATEGORY.FLIGHTS,
        trains: TrackingUtils.CATEGORY.TRAINS,
        hotels: TrackingUtils.CATEGORY.HOTELS,
    }[entryPoint];
    const page = {
        dp: TrackingUtils.PAGE.DP,
        home: TrackingUtils.PAGE.HOME,
        flights: TrackingUtils.PAGE.FLIGHTS,
        trains: TrackingUtils.PAGE.TRAINS,
        hotels: TrackingUtils.PAGE.HOTELS,
    }[entryPoint];
    const value = { tracking: { category, page } };

    return <PageContext.Provider value={value}>{props.children}</PageContext.Provider>;
}

PageContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
